<template>
    <tbody>
    <tr :class="[{more_info: isEditable && $_updateActionAllowed}, { open: isOpen }, {disabled: !isEditable}, {deleted: item.deleted}]" @click="triggerIfEditable">
        <td class="no_padding drag_drop"><span></span></td>
      <td class="no_padding">
        <input type="checkbox"
               :id="item.id_epg"
               :value="item.id_epg"
               @change="onChange"
               :checked="isChecked"
               @click.stop
        />
        <label :for="item.id_epg" @click.stop v-translate>Vybrat</label>
      </td>
        <td :data-th="'Kanál' | translate" class="first_data">{{ item.channel_name }}<channel-video-quality-label :quality="item.video_quality"></channel-video-quality-label></td>
        <td data-th="ID">{{ item.id_channel }}</td>
        <td data-th="ID EPG">{{ item.id_epg }}</td>
        <td data-th="" v-for="(linearProtocolId, index) in linearProtocolIds" :data-th="linearTitles[index]">
            <img class="is_set" src="../../../../assets/images/is-set.svg" :alt="'Ano' | translate"
                 v-if="item.linear_protocols_allowed_channel_ids[linearProtocolId]">
        </td>
        <td data-th="" v-for="(nonlinearProtocolId, index) in nonlinearProtocolIds" :data-th="nonlinearTitles[index]">
            <img class="is_set" src="../../../../assets/images/is-set.svg" :alt="'Ano' | translate"
                 v-if="originalNonlinearSettings.allowed_protocol_ids[nonlinearProtocolId]">
        </td>
        <template v-if="nonlinearProtocolIds">
            <td :data-th="'TimeShift' | translate">
                <img class="is_set" src="../../../../assets/images/is-set.svg" :alt="'Ano' | translate"
                     v-if="originalNonlinearSettings.has_timeshift">
                <span v-if="timeshiftAllowedProtocols">({{ timeshiftAllowedProtocols }})</span><br>
                <template v-if="originalTimeshiftOverride">{{ originalTimeshiftOverride }} min</template>
            </td>
            <td :data-th="'CatchUp' | translate">
                <img class="is_set" src="../../../../assets/images/is-set.svg" :alt="'Ano' | translate"
                     v-if="originalNonlinearSettings.has_catchup">
                <span v-if="catchupAllowedProtocols">({{ catchupAllowedProtocols }})</span><br>
                <template v-if="originalCatchupOverride">{{ originalCatchupOverride }} h</template>
            </td>
            <td :data-th="'PVR' | translate">
                <img class="is_set" src="../../../../assets/images/is-set.svg" :alt="'Ano' | translate"
                     v-if="originalNonlinearSettings.has_pvr">
                <span v-if="pvrAllowedProtocols">({{ pvrAllowedProtocols }})</span><br>
                <template v-if="originalPvrOverride">{{ originalPvrOverride }} dní</template>
            </td>
        </template>
        <td class="no_padding edit">
            <div class="edit_inner" v-if="isEditable">
                <a
                    v-if="$_updateActionAllowed"
						class="btn btn_action btn_delete"
						:title="'Smazat' | translate"
						@click.stop.prevent="emitDelete"
						v-translate>Smazat
				</a>
            </div>
        </td>
    </tr>

    <!-- EDITABLE ROW START -->

    <tr :class="['more_info_content', { open: isOpen }]">
        <td colspan="2"><p></p></td>
        <td>
            <p v-for="profile in sortedProfiles">
                <a
												class="btn btn_action btn_delete"
						:title="'Smazat profil' | translate"
                   		@click.stop.prevent="emitDeleteProfile(profile.id_stream_profile)"
						v-translate>Smazat profil
				</a>
              <label><span>({{ profile.stream_profile_code }})</span> {{ profile.stream_profile_name }}
					<span v-translate>(MC adresa)</span
				></label>
                <input type="text" v-model="profile.mc_ip">
                <span v-if="contentSourceIsVirtual && profile.physical_hostname">({{ profile.physical_hostname }}) </span>
                <span v-if="contentSourceIsVirtual">{{ profile.mc_ip_combined }}</span>
            </p>
        </td>
        <td><p></p></td>
        <td><p></p></td>

        <!-- LINEAR PROTOCOLS -->

        <td v-for="linearProtocolId in linearProtocolIds">
            <checkbox-input
                    p-class="checkbox"
                    :id="editedItem.id_channel + '-' + linearProtocolId + 'linear-protocol'"
                    v-model="editedItem.linear_protocols_allowed_channel_ids[linearProtocolId]"
            >{{ protocolNames[linearProtocolId] }}
            </checkbox-input>
        </td>

        <!-- NONLINEAR PROTOCOLS -->

        <td v-for="nonlinearProtocolId in nonlinearProtocolIds">
            <checkbox-input
                    p-class="checkbox"
                    :id="editedItem.id_channel + '-' + nonlinearProtocolId + '-nonlinear-protocol'"
                    v-model="editedNonlinearSettings.allowed_protocol_ids[nonlinearProtocolId]"
            >{{ protocolNames[nonlinearProtocolId] }}
            </checkbox-input>
        </td>

        <!-- NONLINEAR CONTENT SETTINGS -->

        <template v-if="nonlinearProtocolIds">
            <td>
                <p>
                    <input
							:id="editedItem.id_channel + '-timeshift'"
							type="checkbox"
							v-model="hasTimeshift"
							:disabled="!isTimeshiftAllowed || !isProvidedByAnyNonlinearProtocol">
                    <label
							:for="editedItem.id_channel + '-timeshift'"
							:class="{disabled: !isTimeshiftAllowed || !isProvidedByAnyNonlinearProtocol}"
							v-translate>TimeShift
					</label>
                    <input
							type="text"
							v-model="editedNonlinearSettings.timeshift_override"
							:disabled="!isTimeshiftAllowed || !isProvidedByAnyNonlinearProtocol || !hasTimeshift">
                </p>
            </td>
            <td>
                <p>
                    <input
							:id="editedItem.id_channel + '-catchup'"
							type="checkbox"
							v-model="hasCatchup"
							:disabled="!isCatchupAllowed || !isProvidedByAnyNonlinearProtocol">
                    <label
							:for="editedItem.id_channel + '-catchup'"
							:class="{disabled: !isCatchupAllowed || !isProvidedByAnyNonlinearProtocol}"
							v-translate>CatchUp
					</label>
                    <input
							type="text"
							v-model="editedNonlinearSettings.catchup_override"
							:disabled="!isCatchupAllowed || !isProvidedByAnyNonlinearProtocol || !hasCatchup">
                </p>
            </td>
            <td>
                <p>
                    <input
							:id="editedItem.id_channel + '-pvr'"
							type="checkbox"
							v-model="hasPvr"
							:disabled="!isPvrAllowed || !isProvidedByAnyNonlinearProtocol">
                    <label
							:for="editedItem.id_channel + '-pvr'"
							:class="{disabled: !isPvrAllowed || !isProvidedByAnyNonlinearProtocol}"
							v-translate>PVR
					</label>
                    <input
							type="text"
							v-model="editedNonlinearSettings.pvr_override"
							:disabled="!isPvrAllowed || !isProvidedByAnyNonlinearProtocol || !hasPvr">
                    <input
							class="btn"
							type="submit"
							:value="'Uložit' | translate"
							@click.stop.prevent="emitSubmit">
                </p>
            </td>
        </template>
        <td><p></p></td>
    </tr>
    </tbody>
</template>

<script>
import ChannelVideoQualityLabel from "../../../common/ChannelVideoQualityLabel";

	export default {
		name: "ContentSourceContentRow",
    components: {ChannelVideoQualityLabel},
		created(ContentSourceService) {
			this.contentSourceService = ContentSourceService
			this.itemCopy = this._.cloneDeep(this.item)
		},
		data() {
			return {
				isOpen: false,
				itemCopy: null,
			}
		},
		watch: {
			item(newItem, oldItem) {
				if (newItem !== oldItem) {
					this.itemCopy = this._.cloneDeep(this.item)
				}
			},
		},
		props: {
			item: Object,
			selectedItems: Array,
			isEditable: Boolean,
			urlTemplates: Array,
			protocolNames: Object,
			linearProtocolIds: Array,
			nonlinearProtocolIds: Array,
			nonlinearSettingsAllowed: Object,
      contentSourceIsVirtual: Boolean,
      linearTitles: Array,
      nonlinearTitles: Array,
		},
		computed: {
			editedItem() {
				return this.itemCopy
			},
			isChecked() {
				return this.selectedItems.indexOf(this.item.id_epg) > -1
			},
			originalNonlinearSettings() {
				return this.item.nonlinear_content_settings
			},
			editedNonlinearSettings() {
				return this.editedItem.nonlinear_content_settings
			},
			isTimeshiftAllowed() {
				let isAllowed = false
				this._.forEach(this.nonlinearSettingsAllowed['timeshift'], (idProtocol) => {
					if (this.editedNonlinearSettings.allowed_protocol_ids[idProtocol] === true) {
						isAllowed = true
					}
				})
				return isAllowed
			},
			isCatchupAllowed() {
				let isAllowed = false
				this._.forEach(this.nonlinearSettingsAllowed['catchup'], (idProtocol) => {
					if (this.editedNonlinearSettings.allowed_protocol_ids[idProtocol] === true) {
						isAllowed = true
					}
				})
				return isAllowed
			},
			isPvrAllowed() {
				let isAllowed = false
				this._.forEach(this.nonlinearSettingsAllowed['pvr'], (idProtocol) => {
					if (this.editedNonlinearSettings.allowed_protocol_ids[idProtocol] === true) {
						isAllowed = true
					}
				})
				return isAllowed
			},
			timeshiftAllowedProtocols() {
				return this.settingAllowedProtocols('timeshift_allowed_protocol_ids')
			},
			catchupAllowedProtocols() {
				return this.settingAllowedProtocols('catchup_allowed_protocol_ids')
			},
			pvrAllowedProtocols() {
				return this.settingAllowedProtocols('pvr_allowed_protocol_ids')
			},
			isProvidedByAnyNonlinearProtocol() {
				let isProvided = false
				this._.forEach(this.nonlinearProtocolIds, (nonlinearProtocolId) => {
					if (this.editedNonlinearSettings.allowed_protocol_ids[nonlinearProtocolId] === true) {
						isProvided = true
					}
				})
				return isProvided
			},
			hasTimeshift: {
				get() {
					return this.editedNonlinearSettings.has_timeshift
				},
				set(newValue) {
					this.editedNonlinearSettings.has_timeshift = newValue
				}
			},
			hasCatchup: {
				get() {
					return this.editedNonlinearSettings.has_catchup
				},
				set(newValue) {
					this.editedNonlinearSettings.has_catchup = newValue
				}
			},
			hasPvr: {
				get() {
					return this.editedNonlinearSettings.has_pvr
				},
				set(newValue) {
					this.editedNonlinearSettings.has_pvr = newValue
				}
			},
			originalTimeshiftOverride() {
				return this.originalNonlinearSettings.timeshift_override
			},
			originalCatchupOverride() {
				return this.originalNonlinearSettings.catchup_override
			},
			originalPvrOverride() {
				return this.originalNonlinearSettings.pvr_override
			},
      sortedProfiles(){
        let data = Object.values(this.editedItem.profiles);
        data.sort((a,b) => (a.stream_profile_code > b.stream_profile_code) ? 1 : ((a.stream_profile_code < b.stream_profile_code)? -1 : 0));
        return data;
      }
		},
		methods: {
			onChange: function (e) {
				this.$emit('input', e)
			},
			emitDelete() {
				this.$emit('delete-channel-from-content-source', {id_channel: this.item.id_channel})
			},
			emitDeleteProfile(idProfile) {
				if (this._.keys(this.item.profiles).length > 1) {
					this.$emit('delete-content-from-content-source', {
						id_channel: this.item.id_channel,
						id_stream_profile: idProfile
					})
				} else {
					this.emitDelete()
				}
			},
			triggerIfEditable() {
				if (this.isEditable && this.$_updateActionAllowed) {
					this.isOpen = !this.isOpen
				}
			},
			settingAllowedProtocols(key) {
				let protocols = []
				if (this.nonlinearProtocolIds.length !== this.editedNonlinearSettings[key].length) {
					this._.forEach(this.editedNonlinearSettings[key], (id) => {
						protocols.push(this.protocolNames[id])
					})
				}
				return this._.join(protocols, ', ')
			},
			emitSubmit() {
				const nonlinearSettingsKeys = ['has_timeshift', 'has_catchup', 'has_pvr', 'timeshift_override', 'catchup_override', 'pvr_override']

				let data = {
					id_channel: this.item.id_channel,
					profiles: [],
					linear_protocols_add: [],
					linear_protocols_remove: [],
					nonlinear_protocols_add: [],
					nonlinear_protocols_remove: [],
					nonlinear_settings_update: {},
				}

				// PROFILES
				this._.forEach(this.editedItem.profiles, (profile, idProfile) => {
					if (profile.mc_ip !== this.item.profiles[idProfile].mc_ip) {
						data['profiles'].push({id: idProfile, mc_ip: profile.mc_ip})
					}
				})

				// LINEAR
				this._.forEach(this.linearProtocolIds, (idProtocol) => {
					if (this.editedItem.linear_protocols_allowed_channel_ids[idProtocol] !== this.item.linear_protocols_allowed_channel_ids[idProtocol]) {
						if (this.editedItem.linear_protocols_allowed_channel_ids[idProtocol]) {
							data['linear_protocols_add'].push(idProtocol)
						} else {
							data['linear_protocols_remove'].push(idProtocol)
						}
					}
				})

				// NONLINEAR
				const originalSettings = this.item.nonlinear_content_settings
				const editedSettings = this.editedItem.nonlinear_content_settings

				this._.forEach(originalSettings.allowed_protocol_ids, (value, idProtocol) => {
					if (editedSettings.allowed_protocol_ids[idProtocol] !== value) {
						if (editedSettings.allowed_protocol_ids[idProtocol]) {
							data['nonlinear_protocols_add'].push(idProtocol)
						} else {
							data['nonlinear_protocols_remove'].push(idProtocol)
						}
					}
				})

				const changedSettings = this.changedNonlinearSettings(originalSettings, editedSettings, nonlinearSettingsKeys)
				if (changedSettings.length > 0) {
					data['nonlinear_settings_update'] = this._.pick(editedSettings, changedSettings)
				}

				this.$emit('submit', data)
			},
			changedNonlinearSettings(original, edited, keys) {
				let changed = []
				this._.forEach(keys, (key) => {
					if (original[key] !== edited[key]) {
						changed.push(key)
					}
				})
				return changed
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/contentsources/content/ContentSourceContentRow.vue